/* eslint-disable */
import {
  util,
  browser,
  user,
  storage,
} from '../ws-hybrid';
import ajax from '../ws-util/ajax';

let pageFrom = util.getUrlParam('from');
if (pageFrom == 'pc') {
  pageFrom = util.getUrlParam('orifrom');
}

const isFixedEntry = pageFrom == 'discovery';

let pageAttach = util.getUrlParam('attach');
if (isFixedEntry && !pageAttach) {
  pageAttach = 'cp_reserves3_1';
}
// 二次分享的reserves16_2
if (!~pageAttach.indexOf('cp_reserves16')) {
  pageAttach += `${pageAttach ? '|' : ''}cp_reserves16_1`;
}

const pageEnv = parseInt(util.getUrlParam('env'));

const pageWns = util.getUrlParam('wns'); // 不要parseInt

// eslint-disable-next-line no-mixed-operators
const ua = (window && window.navigator && window.navigator.userAgent) || '';
const isWSLite = ua.toLowerCase().indexOf('lite') > -1;

/**
 * @class ComPageInfo
 */
class ComPageInfo {
  constructor() {
    this.isFixedEntry = isFixedEntry;
    this.pageFrom = pageFrom;
    this.pageAttach = pageAttach;
    this.pageEnv = pageEnv;
    this.packageId = parseInt(util.getUrlParam('pkg'));
    this.quitDownloadBtn = util.getUrlParam('quitDownloadBtn');
    this.authInfo = null;
    this.isWSLite = isWSLite;
  }

  autoInit() {
    if (!window.document) {
      // 只有异步走这个逻辑
      return;
    }

    // 罗盘用这个qua
    let quaSub = 'IDC';
    const clientQuaMap = {
      qzone: 'QZ',
      qq: 'SQ',
      wx: 'WX',
      ws: 'WS',
    };
    if (clientQuaMap[browser.client]) {
      quaSub = `${browser.platform == 'ios' ? 'IPH' : 'AND'}${
        clientQuaMap[browser.client]
      }`;
    }
    browser.quaForCompass = `V1_HT5_H5WEISHI_1.0.0_001_${quaSub}_NEW`;

    // eslint-disable-next-line no-underscore-dangle
    this.authInfo = (window.__INITIAL_STATE__ && window.__INITIAL_STATE__.authInfo)
      || (window.syncData && window.syncData.authInfo)
      || {};

    this.fixCookies();

    // hack一下ajax
    /* eslint-disable */
    ajax.request = this.getRequest(conf, ajax.request)
  }

  getRequest(conf, oriRequestFunc) {
    if (conf && conf.url) {
      let newUrl = conf.url;

      if (browser.client == 'ws') {
        // 微视种的cookie有问题，在weishi_proxy里处理一下再转给proxy_domain
        newUrl = newUrl.replace(
          /(\/weishi)?\/proxy\/domain\//,
          '/weishi/proxy/domain/',
        );
      }

      if (/\/webapp\/jsonp?\/weishi/.test(newUrl)) {
        // 收归微视nodecgi需要的参数，不用每个请求都自己写
        const urlParam = {};

        this.updateUrlParam1(newUrl, urlParam)

        if (this.authInfo && this.authInfo.guid) {
          this.updateUrlParam2(newUrl, urlParam)
        }
        newUrl = util.appendUrlParam(newUrl, urlParam);
      }

      if (newUrl !== conf.url) {
        // eslint-disable-next-line no-param-reassign
        conf.url = newUrl;
      }
    }
    // 用apply是为了保证原始request里的this正确和把所有参数都传过去
    // eslint-disable-next-line prefer-rest-params
    return oriRequestFunc.apply(ajax, arguments);
  }

  updateUrlParam1(newUrl, urlParam) {
    if (pageFrom && !newUrl.match(/(\?|&)from=(.*?)(&|#|$)/)) {
      urlParam.from = pageFrom;
    }
    if (pageEnv && !newUrl.match(/(\?|&)env=(.*?)(&|#|$)/)) {
      urlParam.env = pageEnv;
    }
    if (pageWns && !newUrl.match(/(\?|&)wns=(.*?)(&|#|$)/)) {
      urlParam.wns = pageWns;
    }
  }

  updateUrlParam2(newUrl, urlParam) {
    // 有guid的匿名登录模式，带上guid、iChid、personid（这是后台分配的假personid，不写到cookie的）
    if (
      this.authInfo.guid
      && !newUrl.match(/(\?|&)guid=(.*?)(&|#|$)/)
    ) {
      urlParam.guid = this.authInfo.guid;
    }
    if (
      this.authInfo.iChid
      && !newUrl.match(/(\?|&)iChid=(.*?)(&|#|$)/)
    ) {
      urlParam.iChid = this.authInfo.iChid;
    }
    if (
      this.authInfo.personid
      && !newUrl.match(/(\?|&)personid=(.*?)(&|#|$)/)
    ) {
      // 暂时留着，后面要去掉
      urlParam.personid = this.authInfo.personid;
    }
    if (
      this.authInfo.personid
      && !newUrl.match(/(\?|&)_auth_personid=(.*?)(&|#|$)/)
    ) {
      // personid可能和请求参数冲突，改用_auth_personid
      // eslint-disable-next-line no-underscore-dangle
      urlParam._auth_personid = this.authInfo.personid;
    }
  }

  fixCookies() {
    // 处理下走wns导致没有种上cookie的情况。。。
    if (
      (browser.client === 'qq' || browser.client === 'qzone')
      && this.authInfo
      && this.authInfo.authtype == 1
      && this.authInfo.uin == user.getUin()
      && this.authInfo.openid
      && this.authInfo.openkey
      && this.authInfo.personid
      && storage.cookie.get('person_id') != this.authInfo.personid
    ) {
      const { authInfo } = this;
      const domain = authInfo.domain
        || (window.location.hostname.match(/\.qzone\.qq\.com$/)
          ? 'qzone.qq.com'
          : 'weishi.qq.com');
      const path = '/';
      const hour = 1; // 1小时过期
      const cookieObj = {
        sAuthId: authInfo.uin,
        iAuthType: authInfo.authtype,
        openid: authInfo.openid,
        sSessionKey: authInfo.openkey,
        person_id: authInfo.personid || '',
        iRegType: authInfo.regtype || '',
        iAuthTime: authInfo.timestamp,
      };
      console.log('set cookie to', domain, path, cookieObj);
      // eslint-disable-next-line guard-for-in
      for (const k in cookieObj) {
        storage.cookie.set(k, cookieObj[k], domain, path, hour);
      }
      console.log('new document.cookie', document.cookie);
    }
  }

  getWSQuaString() {
    const tempUa = (window.navigator && window.navigator.userAgent) || '';
    const wsQuaReg = /(V\S+_\S+_WEISHI_\S+_\S+_\S+(_\S+)?)/i;
    let qua = (tempUa.match(wsQuaReg) || [])[1] || '';
    if (qua) {
      // eslint-disable-next-line prefer-destructuring
      qua = qua.split('/')[0];
    }

    // qua split('_') 长度少于7，强制补齐
    const quaSplit = qua.split('_');
    if (quaSplit.length < 7) {
      qua += '_placeholder';
    }

    return qua;
  }

  getWSQuaObj() {
    // 兼容大小写
    const strQua = this.getWSQuaString().toUpperCase();
    const arr = strQua.split('_');
    const OS_REG = /^(AND|IOS|IPH)$/;
    const APP_REG = /^[a-zA-Z]+$/;
    const VER_REG = /^\d+\.\d+\.\d+$/;
    const SUB_VER_REG = /^\d+$/;
    let res;
    if (
      arr.length == 7
      && OS_REG.test(arr[1])
      && APP_REG.test(arr[2])
      && VER_REG.test(arr[3])
      && SUB_VER_REG.test(arr[4])
    ) {
      res = {
        os: arr[1],
        app: arr[2],
        version: arr[3],
        subVersion: arr[4],
        appType: arr[5],
      };
    } else {
      res = {};
    }
    return res;
  }

  compareWSVersion(target, cmd) {
    const compare = function (tokens1, tokens2, p) {
      if (!tokens1[p] && !tokens2[p]) {
        return 0;
      }
      return (
        (tokens1[p] || 0) - (tokens2[p] || 0)
        || compare(tokens1, tokens2, p + 1)
      );
    };
    const { version } = this.getWSQuaObj();

    // 如果没有直接返回false，不需要再运算了
    if (!version) {
      return false;
    }
    // 递归比较数组每一位

    let r = compare(version.split('.'), `${target}`.split('.'), 0);
    // eslint-disable-next-line no-nested-ternary
    r = r < 0 ? -1 : r > 0 ? 1 : 0;

    switch (cmd) {
      case 'eq':
        return r === 0;
      case 'neq':
        return r !== 0;
      case 'lt':
        return r < 0;
      case 'nlt':
        return r >= 0;
      case 'gt':
        return r > 0;
      case 'ngt':
        return r <= 0;
      default:
        return r;
    }
  }

  pageTimingSpeedMap() {
    // 不支持performance;
    if (
      !(
        window.performance
        && window.performance.timing
        && window.performance.timing
        && window.performance.timing.domainLookupStart
      )
    ) {
      return {};
    }

    const perf = {
      points: {},
      baseTime: 0,
    };
    // perf2 = {
    //     points: {},
    //     baseTime: 0
    // },
    const speedData = {
      1: 'unloadEventStart',
      2: 'unloadEventEnd',
      3: 'redirectStart',
      4: 'redirectEnd',
      5: 'fetchStart',
      6: 'domainLookupStart',
      7: 'domainLookupEnd',
      8: 'connectStart',
      9: 'connectEnd',
      10: 'requestStart',
      11: 'responseStart',
      12: 'responseEnd',
      13: 'domLoading',
      14: 'domInteractive',
      15: 'domContentLoadedEventStart',
      16: 'domContentLoadedEventEnd',
      17: 'domComplete',
      18: 'loadEventStart',
      19: 'loadEventEnd',
      20: 'redirectCount',
    };

    // 找basetime
    // var perfEntry = window.performance.getEntries('navigation')[1]

    let i;
    for (i in speedData) {
      if (window.performance.timing[speedData[i]]) {
        if (
          !perf.baseTime
          || perf.baseTime > window.performance.timing[speedData[i]]
        ) {
          perf.baseTime = window.performance.timing[speedData[i]];
        }
      }
      // if (perfEntry[speedData[i]]) {
      //     if (!perf2.baseTime || perf2.baseTime > perfEntry[speedData[i]]) {
      //         perf2.baseTime = perfEntry[speedData[i]]
      //     }
      // }
    }
    // 补充数据
    // eslint-disable-next-line guard-for-in
    for (i in speedData) {
      perf.points[i] = window.performance.timing[speedData[i]] || perf.baseTime;
      // perf2.points[i] = perfEntry[speedData[i]] || perf2.baseTime
    }
    return perf;
  }
}

export default new ComPageInfo();
